import './UseCases.scss';

// The concrete beat: named things a parish, nonprofit, or business is already
// planning, so nobody has to work out for themselves what a film would even be
// for. Sits after Process — they've just read how it gets made, this is what it
// gets them. The header is "what you'd actually gain" rather than "actually
// make": the six titles below are artifacts, but the argument is the payoff, and
// the lead frames the film as a catalyst for work already in motion rather than
// one more thing to plan.
//
// Not a catalogue of formats. Services further down the page is already that,
// and duplicating it here would be dead weight. This is the shortlist, with the
// payoff attached to each.
const USE_CASES = [
    {
        title: "A capital campaign film",
        body: `The ask, made once and made properly — then made again at every parlor
               meeting, in the mailing, and at the phase-two kickoff a year later,
               without you having to be in the room for it.`,
    },
    {
        title: "The film that opens the event",
        body: `The piece that plays before the ask, when everyone is seated and the
               room has gone quiet. It's what people are still repeating in the parking
               lot afterward.`,
    },
    {
        title: "Event promotion",
        body: `A short cut that fills seats — the festival, the gala, the retreat, the
               conference — running for the weeks before the doors open.`,
    },
    {
        title: "A story film",
        body: `Who you are and why it matters, for everyone meeting you for the first
               time: new families, prospective donors, a foundation reading your
               application.`,
    },
    {
        title: "Witness and testimonial pieces",
        body: `Parishioners, donors, volunteers, or clients saying in their own words
               the things you can't credibly say about yourself.`,
    },
    {
        title: "A welcome or recruiting film",
        body: `For the people deciding whether to join, to give, to volunteer, or to
               take the job.`,
    },
];

// Spread across the verticals on purpose: a visitor should be able to find their
// own organization here without us naming it.
const PLACEMENTS = [
    "Your homepage",
    "Social and YouTube",
    "Email and newsletters",
    "Fundraising campaigns",
    "Recruiting and onboarding",
    "Conferences and events",
    "Grant and sponsor packets",
    "Anniversaries and milestones",
];

function UseCases() {
    return (
        <div className="UseCases" id="uses">
            <div className="UseCases-header-container reveal">
                <span className="UseCases-eyebrow">Put it to work</span>
                <h2 className="UseCases-header">
                    What you'd <span>actually gain.</span>
                </h2>
                <p className="UseCases-lead">
                    A film isn't another deliverable. It's the catalyst for the campaign,
                    the event, and the ask you already have in motion.
                </p>
            </div>

            <div className="UseCases-list reveal">
                <ul>
                    {USE_CASES.map(use => (
                        <li key={use.title}>
                            <b>{use.title}</b>
                            <span>{use.body}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="UseCases-placements reveal">
                <h3>Where it goes to work</h3>
                <ul>
                    {PLACEMENTS.map(place => <li key={place}>{place}</li>)}
                </ul>
            </div>
        </div>
    );
}

export default UseCases;
